<script setup lang="ts">
import { useSelectAlertType } from '../../../model/additional-info/success/info-health-check/select-alert-type.hook'
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'
import RowTaskInfo from '../../task-info/RowTaskInfo.vue'
import SelectAlertType from './info-health-check/SelectAlertType.vue'

defineOptions({
  name: 'InfoHealthCheck',
})

const { isRequired } = useSelectAlertType()

</script>

<template>
  <ListTaskInfo>
    <RowTaskInfo
      title="Alert type"
      :required="isRequired"
    >
      <SelectAlertType />
    </RowTaskInfo>
  </ListTaskInfo>
</template>
